import { FC, useEffect } from 'react'
import { Form, json, replace, useActionData, } from 'react-router-dom'

// COMPONENTS
import TextField from '@components/atoms/textfield'
import Button from '@components/atoms/button'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { createAuthenticatedLoader, useLoader } from '@utils/loaders'
import { isArray, isNonEmptyString, isObject } from '@utils/type-checkers'
import { formatInput } from '@utils/phone-number-helper'
import { createAction } from '@utils/actions'
import { isFailedResponse } from '@apis'
import { useProfilePhoneContext } from '../..'
import { useInput } from '@hooks/inputs'


const Component: FC<{}> = () => {
    const { resource, method } = useLoader<typeof loader>()
    const { setToast } = useProfilePhoneContext()
    const otpProps = useInput()[1]
    const data = useActionData()

    useEffect(() => {
        if (data != null) setToast({ type: 'error', text: isNonEmptyString(data) ? data : 'An unexpected Error occured' });
    }, [setToast, data])

    return (
        <Form className="flex flex-col" style={{ gap: 'inherit' }} method="POST">
            <h4>Change Phone Number</h4>
            {(method === 'replace') && <p>Before we can update your phone number, we need to verify its you!</p>}
            <p>A verification code has been sent to <strong style={{ color: 'black', whiteSpace: 'nowrap' }}>+1 {formatInput(resource.phoneNumber)}</strong>.<br />Enter the 6-digit code below!</p>
            <TextField {...otpProps} type="text" name="otp" placeholder="Verification Code" autoComplete="one-time-code" autoCorrect="off" maxLength={6} required />
            <small>Didn't get the code? Check spam/junk or resend it</small>
            <Button type="submit" theme="primary">Continue</Button>
        </Form>
    )
}

const loader = createAuthenticatedLoader(async ({ request, params }, Clerk) => {
    const phoneId = params['phoneId'] || ''
    const method: 'replace' | 'verify' = !!(new URL(request.url).searchParams.get('replace')) ? 'replace' : 'verify'
    const resource = Clerk.user?.phoneNumbers.find(({ id }) => id === phoneId)

    console.log(request, params, method)

    if (!!resource) {
        if (resource.verification.status !== 'verified' || method === 'replace') await resource.makeDefaultSecondFactor()
        return { resource, method }
    } else return replace('/account/profile')
})

const action = createAction(async ({ request, params }) => {
    try {
        const data = await request.formData()
        const otp = data.get('otp')
        const phoneId = params['phoneId'] || ''
        const resource = window.Clerk?.user?.phoneNumbers.find(({ id }) => id === phoneId)

        if (!!resource && isNonEmptyString(otp)) return await resource.attemptVerification({ code: otp })
            .then((res) => {
                if (res.verification.status === 'verified') return json(null, 200)
                else throw new Error(`An issue occured during verification. Failed with status: ${res.verification.status}`)
            })
            .catch((err) => {
                if (isClerkErr(err) && err.errors[0].code === 'verification_already_verified') return json(null, 200)
                else throw err
            })
        else throw new Error('Unsupported Resource')
    } catch (error) {
        console.error(error)
        if (isFailedResponse(error) || error instanceof Error) return json(error.message);
        else return json('An unexpected Error occured')
    }
})

type ClerkErr = {
    clerk_trace_id?: string
    errors: {
        code: string
        long_message: string
        message: string
    }[]
    meta?: any
}
const isClerkErr = (value: unknown): value is ClerkErr => (
    isObject(value) && isArray(value.errors)
)

const VerifyPhoneRoute: RouteObject = {
    path: "verify",
    Component,
    loader,
    action,
}

export { VerifyPhoneRoute }